import ThemedComponent from '../../hoc/ThemedComponent';
import ProfilePage from './ProfilePage';
import { default as ProfilePage3 } from '../../themes/3/pages/profile/ProfilePage';
import { default as ProfilePage4 } from '../../themes/4/pages/profile/ProfileEditPage';

const ThemedProfilePages = {
  default: ProfilePage,
  // 3: ProfilePage3,
  // 4: ProfilePage4,
};

export const ThemedProfilePage = ThemedComponent(ThemedProfilePages);
